import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal } from '../../../../components/Modal';
import { Cell } from '../Cell';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { VBox } from '../../../../components/Box';
import { CardCompanyHeader } from '../../../Companies/components/CardCompanyHeader';
import { getPropByName } from '../../../../utils/props';
import { CompanyKYCActionsCard } from '../../components/ModalKYC';
import { KYC_REQ_DOCUMENTS_NL, KYC_REQ_DOCUMENTS_NL_IDW, KYC_REQ_FIELDS_IN, KYC_REQ_FIELDS_IN_IDW } from '../../../Companies/constants';
import { toggleKanbanCompanyModal } from '../../actions';
import { selectKanbanCompanyToggle } from '../../selectors';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
const Container = styled.div`
  .formField {
    width: 100%;
    .form-controlField {
      > div {
        width: 100%;
      }
    }
  }
`;

const STATE = {
  approve: false,
  showKYCModal: false,
};

/* eslint-disable react/prefer-stateless-function */
class ACC_NL_inComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {}

  get company() {
    return this.props.cell.company;
  }

  get relationNumber() {
    const relationNumber = getPropByName(this.company, 'customernumber');
    return `Relationnummer: ${relationNumber}`;
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return <Modal onClose={this.reset.bind(this)} title={this.props.action.label}></Modal>;
  }

  toggle() {
    return this.props.toggleModal(this.company?.id, this.props.action?.functionName);
  }

  render() {
    const company = this.company;

    return (
      <Cell key={company?.id}>
        <Container>
          {this.props.isShowModal?.isShow &&
            this.props.isShowModal?.entityId == company?.id &&
            this.props.action?.functionName == this.props.isShowModal?.actionName && (
              <CompanyKYCActionsCard
                company={this.company}
                editableStatus
                requiredFields={env.clientId !== AppClientId.INDEWAL ?  KYC_REQ_FIELDS_IN : KYC_REQ_FIELDS_IN_IDW}
                requiredDocuments={env.clientId !== AppClientId.INDEWAL ? KYC_REQ_DOCUMENTS_NL : KYC_REQ_DOCUMENTS_NL_IDW}
                action={this.props.action}
                board_id={this.props.board_id}
                column={this.props.column}
              />
            )}
          <VBox style={{ cursor: 'pointer' }} onClick={this.toggle.bind(this)}>
            <CardCompanyHeader company={company} action={this.props.action} />
            {this.relationNumber && <span style={{ color: '#aaa', fontSize: '14px' }}>{this.relationNumber}</span>}

            <CellButtons>
              {this.props.cell.busy ? (
                <Loader small />
              ) : (
                <>
                  <CellButton>
                    <View />
                  </CellButton>
                </>
              )}
            </CellButtons>
          </VBox>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

ACC_NL_inComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    isShowModal: selectKanbanCompanyToggle(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    toggleModal(companyId, actionName) {
      dispatch(toggleKanbanCompanyModal(companyId, actionName));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const acc_nl_in = compose(withConnect, withRouter)(ACC_NL_inComp);
